<template>
  <svg :height="height" :width="width" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.40625 12.5938C2.83125 12.0188 3.2125 10.8125 2.91875 10.1062C2.625 9.4 1.5 8.78125 1.5 8C1.5 7.21875 2.6125 6.625 2.91875 5.89375C3.225 5.1625 2.83125 3.98125 3.40625 3.40625C3.98125 2.83125 5.1875 3.2125 5.89375 2.91875C6.6 2.625 7.21875 1.5 8 1.5C8.78125 1.5 9.375 2.6125 10.1062 2.91875C10.8375 3.225 12.0188 2.83125 12.5938 3.40625C13.1687 3.98125 12.7875 5.1875 13.0813 5.89375C13.375 6.6 14.5 7.21875 14.5 8C14.5 8.78125 13.3875 9.375 13.0813 10.1062C12.775 10.8375 13.1687 12.0188 12.5938 12.5938C12.0188 13.1687 10.8125 12.7875 10.1062 13.0813C9.4 13.375 8.78125 14.5 8 14.5C7.21875 14.5 6.625 13.3875 5.89375 13.0813C5.1625 12.775 3.98125 13.1687 3.40625 12.5938Z" :stroke="stroke" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 5V8.5" :stroke="stroke" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.125 10.75C8.125 10.819 8.06904 10.875 8 10.875C7.93096 10.875 7.875 10.819 7.875 10.75C7.875 10.681 7.93096 10.625 8 10.625C8.06904 10.625 8.125 10.681 8.125 10.75Z" fill="#4D4D4D" :stroke="stroke"/>
  </svg>
</template>

<script>
export default {
  props: {
    height: {type: String, default: '24'},
    width: {type: String, default: '24'},
    fill: {type: String, default: 'none'},
    stroke: {type: String, default: '#6886A6'},
    viewBox: {type: String, default: '0 0 24 24'}
  }
}
</script>